<template>
  <div class="charge">
    <div class="title">
      收费情况
    </div>
    <div v-if="type === 'matter'" class="contentWrapper">
      <div>
        <div class="num1" style="font-size: 16px">{{ message ? message:'暂无描述' }}</div>
      </div>
      <div v-if="chargeInfo.length > 0">
        <div v-for="(item,index) in chargeInfo" :key="index">
          <div class="num1" style="font-size: 16px">收费依据:</div>
          <p class="detail" >
            {{ item.chargeName }}：{{ item.chargeLegal }}
          </p>
        </div>
      </div>
    </div>
    <div class="contentWrapper" v-if="type === 'oneThing'">
      <div class="num1" style="font-size: 16px">{{ message }}</div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    chargeInfo: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'matter'
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
.charge {
  .contentWrapper {
    margin-top:15px;
    border: 1px solid rgba(238, 238, 238, 1);
    padding:30px;
    line-height: 30px;
  }
  .title {
    font-size: 22px;
    color: #333333;
    font-weight: 500;
  }
  .num {
    font-size: 24px;
    color: #1677ff;
  }
  .detail {
    font-size: 14px;
    color: #666666;
  }
}
</style>
